import {
  LEGAL_PAGE_IDS,
  LEGAL_VALUES,
  legalDescription,
  legalDocMeta,
  type LegalPageId,
} from '../../legal/index.ts';
import type { PageSeo } from '../../types.ts';

/**
 * Copy của 7 trang pháp lý — SUY RA từ namespace pháp lý, KHÔNG gõ lại.
 *
 * 7 trang × 4 chuỗi = 28 chuỗi mỗi ngôn ngữ. Gõ tay 28 chuỗi trích từ một file khác là 28 cơ hội
 * sai chính tả trên dữ liệu của văn bản pháp lý, và không cổng nào bắt được một chữ gõ sai ở đây.
 * Nên chỗ này TRA, không CHÉP.
 *
 * Vì sao phải có file này: `types.ts` chốt ở mức KIỂU rằng `copy.seo` và `copy.page` phủ ĐỦ mọi
 * `PageId`. Thêm 7 `PageId` mà không có copy là typecheck ĐỎ — không phải quy ước, là kiểu.
 *
 * File RIÊNG chứ không sửa `common.ts`: docblock `index.ts` khai *"lô sau THÊM một file và MỘT
 * dòng ở đây, không sửa dòng nào của lô khác"*. Lô D vừa land theo đúng nếp đó.
 */
const LOCALE = 'vi' as const;

/** `<title>` khớp `main/src/lib/components/LegalPage.svelte:31`: `{title} — {appName}`. */
function seoTitle(id: LegalPageId): string {
  return `${legalDocMeta(id, LOCALE).title} — ${LEGAL_VALUES.appName}`;
}

function buildSeo(): Record<LegalPageId, PageSeo> {
  const out = {} as Record<LegalPageId, PageSeo>;
  for (const id of LEGAL_PAGE_IDS) {
    out[id] = { title: seoTitle(id), description: legalDescription(id, LOCALE) };
  }
  return out;
}

/**
 * `heading` là h1 THẬT của trang — thân văn bản đã trích có 0 thẻ `<h1>` (đã đo), h1 do
 * `LegalPage` render từ prop `title`. Nên đây là chuỗi được dùng, không phải chuỗi chết.
 *
 * LƯU Ý — KHÔNG dùng emoji trong file này: `script/check-fonts.mjs` đọc CẢ chú thích của
 * `copy/**` như thể là chữ người dùng thấy, nên một emoji trong docblock làm cổng font ĐỎ.
 *
 * `body` LÀ DỮ LIỆU CHẾT: kiểu đòi nó (`page: Record<PageId, { heading, body }>`), nhưng
 * `copy.page` chỉ được đọc ở `HeroSection.tsx:67,73` cho `home`. Không code nào render
 * `page.<legalId>.body`. User chốt 2026-08-20 dùng LẠI `description` thay vì trích thêm một
 * đoạn nữa — trích thêm là nhân đôi văn bản pháp lý ở một chỗ không cổng nào canh.
 */
function buildPage(): Record<LegalPageId, { heading: string; body: string }> {
  const out = {} as Record<LegalPageId, { heading: string; body: string }>;
  for (const id of LEGAL_PAGE_IDS) {
    out[id] = { heading: legalDocMeta(id, LOCALE).title, body: legalDescription(id, LOCALE) };
  }
  return out;
}

export const legalSeo = buildSeo();
export const legalPage = buildPage();

/**
 * Nhãn giao diện của trang pháp lý — CHÉP từ `main/src/lib/i18n.ts:34-41`, không dịch lại.
 * Sáu chuỗi này là thứ `LegalPage.svelte` và `VersionSwitcher.svelte` render.
 */
export const legalUi = {
  effectiveDate: 'Ngày hiệu lực',
  lastUpdated: 'Cập nhật lần cuối',
  versionLabel: 'Phiên bản',
  versionCurrent: 'hiện hành',
  versionArchived: 'lưu trữ',
  versionViewing: 'đang xem',
};
